import __Layout from './Layout.jsx';
import Login from './pages/Login.jsx';
import GolfBooking from './pages/GolfBooking.jsx';
import MyBookings from './pages/MyBookings.jsx';
import Profile from './pages/Profile.jsx';
import AboutUs from './pages/AboutUs.jsx';
import ContactUs from './pages/ContactUs.jsx';
import PackageDetail from './pages/PackageDetail.jsx';
// import PackageCheckout from './pages/PackageCheckout.jsx';
import BookingFlow from './pages/PackageBookingFlow.jsx';
import GolfGetaways from './pages/GolfGetaways.jsx';
import BookingConfirmation from './pages/BookingConfirmation.jsx';
import ExquraExperience from './pages/ExquraExperience.jsx';
import DataDeletion from './pages/DataDeletion.jsx';
import ExperienceDetail from './pages/ExperienceDetail.jsx';
import SingpassCallback from './pages/SingpassCallback.jsx';
import SingpassCallbackPopup from './pages/Callbackpopup.jsx';
import GolferDetails from './pages/Golferdetailspage.jsx';
import createCmsPage from './cms/createCmsPage.jsx';
import { CreateCoursePage as CreateCourse, CreateGatewayPage as CreateGetaway,
    CreateFerriesPage as CreateFerry,CreateTransportPage as CreateTransport,CreateAccommodationPage as CreateAccommodation,
    CreateTemplatePage as CreateTemplate, AdminManageBookingsPage as AdminManageBookings, CreateCouponPage as CreateCoupon,
    EditSitePage as EditSite, SettingsPage as Settings
 } from './pages/admin/wrappers.jsx';

export const PAGES = {
    "Login": Login,
    "about-courses": GolfBooking,
    "my-bookings": MyBookings,
    "Profile": Profile,
    "AboutUs": AboutUs,
    "ContactUs": ContactUs,
    "package-detail": PackageDetail,
    "package-checkout": BookingFlow,
    "golf-getaways": GolfGetaways,
    "auth/singpass/callback": SingpassCallback,
    "booking-confirmation": BookingConfirmation,
    "exqura-experience": ExquraExperience,
    "admin/create-course": CreateCourse,
    "admin/create-ferry":CreateFerry,
    "admin/create-transport":CreateTransport,
    "admin/create-accommodation" : CreateAccommodation,
    "admin/create-getaway": CreateGetaway,
    "admin/create-template" : CreateTemplate,
    "admin/manage-bookings" : AdminManageBookings,
    "admin/create-coupon" : CreateCoupon,
    "admin/settings" : Settings,
    "admin/edit-site" : EditSite,
    "privacy-policy": createCmsPage("privacy-policy"),
    "data-deletion": DataDeletion,
    "terms-of-service": createCmsPage("terms-of-service"),
    "help-center": createCmsPage("help-center"),
    "faqs": createCmsPage("faqs"),
    "cancellation-policy": createCmsPage("cancellation-policy"),
    "careers": createCmsPage("careers"),
    "experience-detail": ExperienceDetail,
    "golfer-details" : GolferDetails,
    "auth/singpass/callback-popup": SingpassCallbackPopup,
};

export const pagesConfig = {
    mainPage: "Login",
    Pages: PAGES,
    Layout: __Layout,
};


export const ADMIN_PAGES = ["admin/create-course","admin/create-ferry","admin/create-transport","admin/create-accommodation","admin/create-getaway",
    "admin/create-template","admin/manage-bookings","admin/settings","admin/edit-site","admin/create-coupon"];